/**
 * 对话分享链接的 URL 参数 —— 单独成模块,不依赖 zod / API 层。
 *
 * 全局布局里的 AssistantWindowProvider 只需要这个参数名来识别「打开某段对话」的链接;
 * 以前从 conversationApi 取,而那个模块顶层就构造 zod schema 并拉进 aiApiSupport /
 * @/types/agentic,结果整套 AI 契约代码都被打进了入口 chunk。
 */

/** A link to a conversation: the app opens it in the assistant window (the server decides who may read it). */
export const CONVERSATION_LINK_PARAM = 'assistant_conversation'
export const conversationLink = (conversationId: string) =>
  `${window.location.origin}/?${CONVERSATION_LINK_PARAM}=${encodeURIComponent(conversationId)}`
